import { io } from "socket.io-client";
import { serverAppUrl } from "./apis/mainApi";

export const socket = io(serverAppUrl, {
  transports: ["websocket"],
  autoConnect: false, // VERY IMPORTANT
});
